import { createSelector } from 'reselect';

export const getComponentState = state => state.records;

export const getActionType = createSelector(
    getComponentState,
    (state) => state.actionType
);
export const getPagination = createSelector(
    getComponentState,
    (state) => state.pagination
);
export const getItems = createSelector(
    getComponentState,
    (state) => state.items
);
export const getItem = createSelector(
    getComponentState,
    (state) => state.item
);
export const getFetchingElements = createSelector(
    getComponentState,
    (state) => state.fetchingElements
);
export const getFetchingElement = createSelector(
    getComponentState,
    (state) => state.fetchingElement
);
export const getSaving = createSelector(
    getComponentState,
    (state) => state.saving
);
export const getSort = createSelector(
    getComponentState,
    (state) => state.sort
);
export const getSearch = createSelector(
    getComponentState,
    (state) => state.search
);
export const getSearchType = createSelector(
    getComponentState,
    (state) => state.searchType
);
export const getHistory = createSelector(
    getComponentState,
    (state) => state.history
);
export const getDeleting = createSelector(
    getComponentState,
    (state) => state.deleting
);
export const getIdModal = createSelector(
    getComponentState,
    (state) => state.idModal
);
export const getFile = createSelector(
    getComponentState,
    (state) => state.file
);
export const getUploadingFile = createSelector(
    getComponentState,
    (state) => state.uploadingFile
);
export const getStartDate = createSelector(
    getComponentState,
    (state) => state.startDate
);
export const getEndDate = createSelector(
    getComponentState,
    (state) => state.endDate
);
export const getYear = createSelector(
    getComponentState,
    (state) => state.year
);
export const getMonth = createSelector(
    getComponentState,
    (state) => state.month
);
export const getDeleteType = createSelector(
    getComponentState,
    (state) => state.deleteType
);
export const getFilters = createSelector(
    getComponentState,
    (state) => state.filters
);
export const getOldFilters = createSelector(
    getComponentState,
    (state) => state.oldFilters
);
export const getExportingExcel = createSelector(
    getComponentState,
    (state) => state.exportingExcel
);
export const getFiltersOptions = createSelector(
    getComponentState,
    (state) => state.filtersOptions
);
export const getTotal = createSelector(
    getComponentState,
    (state) => state.total
);
export const getFileType = createSelector(
    getComponentState,
    (state) => state.fileType
);
export const getFormType = createSelector(
    getComponentState,
    (state) => state.formType
);